import { render, staticRenderFns } from "./Groups-Single.vue?vue&type=template&id=ac847322&scoped=true"
import script from "./Groups-Single.js?vue&type=script&lang=js&external"
export * from "./Groups-Single.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac847322",
  null
  
)

export default component.exports